export { default } from './store-info';
